import axiosInstance from '@/utils/api.js'

var state = {
  dialupService: []
}

var getters = {
  DIALUP_SERVICE: (state) => {
    return state.dialupService
  }
}

var mutations = {
  SET_DIALUP_SERVICE: (state, payload) => {
    state.dialupService = payload
  }
}

var actions = {
  GET_DIALUP_SERVICE: async (context, payload) => {
    let result = await axiosInstance.get('/tariffing/services/dialup?service_id=' + payload)
    if (result.status === 200) {
      context.commit('SET_DIALUP_SERVICE', result.data)
    }
  },
  CREATE_DIALUP_SERVICE: (context, payload) => {
    return axiosInstance.post('/tariffing/services/dialup', payload)
  },
  UPDATE_DIALUP_SERVICE: (context, payload) => {
    return axiosInstance.put('/tariffing/services/dialup', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/tariffing/dialupServices.js